import React, { Fragment, useEffect, useState } from 'react';

// Components - material UI
import { Button } from '@material-ui/core';

// Icons - material UI
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const Email = ({
    email,
    emailTodo,
    processing,
    onChange,
    auth,
    chat,
    notification,
    getUnreadChats,
    getUnreadCount,
    history,
    goBack
}) => {

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Notification Badge
    const [badgeValue, setBadgeValue] = useState(0);

    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {

        // Fetch unread counts for notifications and chats
        if(auth.user){
            getUnreadCount(auth.user._id);
            getUnreadChats(auth.user._id);
        }

    }, [notification.notifications, auth.user]);

    useEffect(() => {

        // Update the badge value to total (Notifications + unread Chats)
        setBadgeValue(notification.num_unread + chat.num_unread_chats);

    }, [notification.num_unread, chat.num_unread_chats])

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    return (
        <div className="settings">

            {/* Header */}
            <div className="settings__header">

                {/* Back Btn Icon & Badge Value */}
                <div onClick={goBack} className="profile__btnContainer">
                    <ArrowBackIcon />
                    {isMobile && badgeValue > 0 ? (
                        <span className="feed-header-badge defaultBadge">
                            {badgeValue}
                        </span>
                    ) : null}
                </div>

                {/* Title */}
                <div className="settings__headerText">
                    <h3>
                        Change email
                    </h3>
                </div>
            </div>

            {/* Body */}
            <div className="settings__body">

                {/* Input */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'10px', display:'flex', justifyContent:'center', borderBottom:'1px solid #e6ecf0'}}>
                    <input
                        type="email"
                        placeholder="Email"
                        className="input"
                        name="email"
                        value={email}
                        onChange={e => onChange(e)}
                        // maxlength="30"
                        style={{width: '100%'}}
                    />
                </div>

                {/* Submit */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'0 10px', display:'flex', justifyContent:'flex-end'}}>
                    <Button 
                        disabled={(email === auth.user.email || processing)}
                        variant="outlined" 
                        className={`sidebar__tweet save ${(email === auth.user.email || email === '') ? 'disabled' : ''}`}
                        onClick={emailTodo}
                    >
                        {processing ? 'Processing...' : 'Save'}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export default Email;
